module.exports = __webpack_public_path__ + "article-7051a3ee/bewerbungsschreiben-praktikum-33e32859519d47c93b01e33b5d2dffeb.jpeg";